module.exports = __webpack_public_path__ + "static/media/solar_car.38fe651b.png";